import gsap, { Power4 } from 'gsap';
import Blazy from 'blazy'
import Flickity from 'flickity-fade'
import ParallaxElement from './utils/parallax' 
import Popup from './utils/popup' 
import Sidebar from './utils/sidebar' 
import {smoothScroll} from './utils/utils'
import Cookies from 'js-cookie'
import inView from 'in-view'
import LocomotiveScroll from 'locomotive-scroll';
import customSelect from 'custom-select';

const HTML = document.querySelector('html');

class App {
  constructor() {
    const _ = this;

		let linksAnchor = document.querySelectorAll('a[href*="#"]:not([href="#"],[href*="#cookies"])');
		if( linksAnchor ) linksAnchor.forEach((el) => { 
      el.addEventListener('click', function(e) {
        // We don't want this link interception applying to links with both path and hash.
        if (this.pathname && this.pathname !== window.location.pathname) {
          return;
        }
        e.preventDefault();
        const $target = document.querySelector(this.hash)
        if ($target) {
          let pos = $target.getBoundingClientRect();
          if( _.scroll ) {
            _.scroll.update();
            _.scroll.scrollTo(pos.top + _.scrollY)
          } else {
            gsap.to(
              document.querySelectorAll('html, body'),
              {
                duration: 0.8,
                scrollTop: window.scrollY + pos.top,
                ease: "expo.out"
              }
            )
          }
        }
      }) 
    });

    const header = document.querySelector('.main-header')
    const menus = header.querySelectorAll('.has-children');
    menus.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        header.classList.add('hover');
      })
      link.addEventListener('mouseleave', () => {
        header.classList.remove('hover');
      })
    })
    
    // Nav fixed
    const nav = header.querySelector('.main-nav').cloneNode(true);
    nav.classList.add('clone')
    document.body.append(nav);
    window.addEventListener('scroll', (e) => {
      const pos = header.getBoundingClientRect();

      if( pos.bottom + 100 <= 0 || ( this.scroll && pos.height + 100 <= this.scroll.y) ) {
        nav.classList.add('fixed')
      } else if(nav.classList.contains('fixed')) {
        nav.classList.remove('fixed')
      }
    })

    // Lazyload
    let timerLazy = 0;
		// this.lazyload = new Blazy({
		// 	breakpoints: [{
    //   	width: 420,
		// 		src: 'data-src-small' 
    //  	}],
    //   offset: 600,
    //   successClass : 'loaded',
	  //   selector : '.js-lazy',
	  //   success : function($el) {
    //     if ($el.classList.contains('js-lazy-error-placeholder')) {
    //       $el.lazyLoadPlaceholder = $el.src;
    //     }

    //     clearTimeout(timerLazy);
    //     timerLazy = setTimeout(() => {
    //       if( _.scroll ) _.scroll.update()
    //     }, 200)

    //     const figure = $el.closest('.img');
    //     if( figure ) figure.classList.add('is-loaded')
	  //   }
		// });


		//Parallax
		document.querySelectorAll('.js-parallax').forEach((el) => {
			let _p = new ParallaxElement(el, '.js-parallax', false)
			_p.teardown()
		})

    // In viewport
	  inView.offset(window.innerHeight * .2);
		inView('.js-reveal:not(.is-visible)')
    	.on('enter', function(elt) {
        if( elt.dataset.revealCallback ) {
          const callback = JSON.parse(elt.dataset.revealCallback)
          
          if( callback.bg ) {
            gsap.to(HTML, { duration : 0.5, backgroundColor : callback.bg });
          }
        }

        if( elt.classList.contains('is-visible')) elt.dispatchEvent(new Event('inview'))
        elt.classList.add('is-visible');
      })
      .on('exit', function(elt) {
        if( elt.dataset.revealCallback ) {
          const callback = JSON.parse(elt.dataset.revealCallback)
          
          if( callback.bg ) {
            gsap.to(HTML, { duration : 0.5, backgroundColor : 'transparent' });
          }
        }
      })
      
    // Popup start site
    const popupAdvert = document.querySelector('#popup-welcome')
    if( popupAdvert && !Cookies.get('hide-popup')) {
      const welcome = new Popup(popupAdvert);

      // Hide popup
      const hidePopup = popupAdvert.querySelector('.hide-popup')
      if( hidePopup ) {
        hidePopup.addEventListener('click', (e) => {
          e.preventDefault();
          Cookies.set('hide-popup', 'true', { expires: 7 })
        })
      }

      setTimeout(() => {
        welcome.show();
      }, 400)
    }

    // RGPD
    // @todo à supprimer, utilise tacjs
    const rgpd = document.querySelector('.rgpd')
    if( rgpd ) {
      const accept = rgpd.querySelector('.trigger-accept');
      if( accept ) {
        accept.addEventListener('click', e => {
          e.preventDefault();
          Cookies.set('accept', 'true', { expires: 7 })

          rgpd.classList.remove('-translate-y-full', 'shadow-xl-inv');
        })
      }

      if( !Cookies.get('accept') ) {
        rgpd.classList.add('-translate-y-full', 'shadow-xl-inv');
      }
    }

    // Footer accordion
    const triggerAccordion = document.querySelectorAll('.footer-accordion')
    if( triggerAccordion ) {
      triggerAccordion.forEach(el => {
        el.addEventListener('click', (e) => {
          if( window.innerWidth < 768 ) {
            e.preventDefault();
            el.classList.toggle('open');

            const content = el.nextElementSibling;
            if( content ) {
              const h = content.offsetHeight;
              gsap.to(content, { duration : 0.4, ease : 'circ.inOut', height : h == 0 ? content.children[0].offsetHeight : 0 })
            }
          }
        })
      })
    }

    // Custom select
    const selects = document.querySelectorAll('.form--select select')
    if( selects ) {
      selects.forEach(el => {
        if (!el.classList.contains('custom-select-initiated')) {
          const select = customSelect(el)[0]
          select.select.addEventListener('change', (e) => {
            if( select.value ) {
              select.container.classList.add('select-value')
            } else {
              select.container.classList.remove('select-value')
            }
          })
          el.classList.add('custom-select-initiated');
        }
      });
    }

    // Click on eye to show password
    const eyes = document.querySelectorAll('.icon--eye')
    if( eyes ) {
      eyes.forEach(eye => {
        const parent = eye.parentNode;
        const field = parent.querySelector('input[type="password"]');

        if( field ) {
          if(window.innerWidth > 1380) {
            eye.addEventListener('mousedown', e => {
              e.preventDefault();
              field.setAttribute('type', 'text')
            })
            eye.addEventListener('mouseup', e => {
              e.preventDefault();
              field.setAttribute('type', 'password')
            })
          }
          else {
            eye.addEventListener('touchstart', e => {
              e.preventDefault();
              field.setAttribute('type', 'text')
            })
            eye.addEventListener('touchend', e => {
              e.preventDefault();
              field.setAttribute('type', 'password')
            })
          }
        }
      })
    }

    /******************/
    /*** Init 
    /******************/
    this.menu();
    this.sliderCover();
    this.sliderImg();
    this.carousel();
    this.carouselCenter();
    this.carouselCategory();
    // this.popup();
    this.sidebar();
    // this.selectScroll()
    this.nextStepScroll();
  }

  customScroll() {
    const _ = this;

    // Custom scroll
    if( window.innerWidth > 1380 ) {
      if (this.scroll) {
        this.scroll.update();
        return;
      }
      this.scroll = new LocomotiveScroll({
        el: document.querySelector('.main'),
        smooth: true,
        tablet: {
          breakpoint: 1380,
        },
        reloadOnContextChange: true
      });

      this.scroll.on('scroll', (instance) => {
        this.scrollY = instance.scroll.y
        window.dispatchEvent(new Event('scroll'));
        if(!document.querySelector('.main').classList.contains('custom-scroll-init-proceed')) {
          setTimeout(function () {
            window.dispatchEvent(new Event('resize'));
          }, 1000);
          
          document.querySelector('.main').classList.add('custom-scroll-init-proceed');
        }
      })
      
      this.scroll.on('call', (value, way, obj) => {
        if(value == 'sticky') {
          if( way == 'enter') {
            obj.el.classList.add('sticky-fixed');
            if(!document.querySelector('.main').classList.contains('custom-scroll-init-proceed-sticky')) {
              setTimeout(function () {
                window.dispatchEvent(new Event('resize'));
              }, 1000);
              
              document.querySelector('.main').classList.add('custom-scroll-init-proceed-sticky');
            }
          } else if( way == 'exit' && obj.progress < 0 ) {
            obj.el.classList.remove('sticky-fixed');
          }
        }
      })
    }
  }

  faqScroll() {
    const _ = this;
    // Custom scroll
    const faqQuestion = document.querySelectorAll('.faq-question');

    if (faqQuestion && window.innerWidth > 1380) {
      faqQuestion.forEach(function (el) {
        el.addEventListener('click', function(e) {
          if(this.scroll) {
            _.scroll.update();
            return;
          }
          this.scroll = new LocomotiveScroll({
            el: document.querySelector('.main'),
            smooth: true,
          });
        });
      });
    }
  }

  /** Build trigger popup */
  popup() {
    const _ = this;
    const triggers = document.querySelectorAll('[data-popup]');
    if( triggers ) {
      triggers.forEach(el => {
        if(!el.classList.contains('popup-processed') ) {
          el.classList.add('popup-processed')
          el.addEventListener('click', e => {
            e.preventDefault();
            const modal = document.getElementById(el.dataset.popup);
            if( _.scroll ) this.scroll.el.after(modal)
            if (modal) {
              const popup = new Popup(modal, function() { if( _.scroll ) _.scroll.start() });
              setTimeout(() => {
                popup.show();
              }, 100);
              if( _.scroll ) _.scroll.stop();
            }
          })
        }
      })
    }
  }

  /** Disable scroll on museover event of the custom select */
  selectScroll() {
    const _ = this;
    const customSelect = document.querySelectorAll('.custom-select-panel, .popup-welcome-cb');
    if( customSelect ) {
      customSelect.forEach(el => {
        if(!el.classList.contains('custom-select-processed') ) {
          el.classList.add('custom-select-processed');
          el.addEventListener('mouseover', e => {
            if( _.scroll ) _.scroll.stop();
          });
          el.addEventListener('mouseout', e => {
            if( _.scroll ) _.scroll.start();
          });
        }
      })
    }
  }

  /** Add class to 'block buy' when click on attribute in custom package product **/
  customPackageAtribute() {
    const _ = this;
    const customPackageAtribute = document.querySelectorAll('.product-custom-package .product__choice input[type="radio"]');
    if( customPackageAtribute ) {
      customPackageAtribute.forEach(el => {
        if (!el.classList.contains('custom-package-attribute-initiated')) {
          el.addEventListener('click', (e) => {
            document.querySelector('.product-custom-package-block-buy').classList.add('sticky-fixed');
          })
          el.classList.add('custom-package-attribute-initiated');
        }
      });
    }
  }
   
  /**
   * Build trigger sidebar
   */
  sidebar() {

    const triggers = document.querySelectorAll('[data-sidebar]');
    if( triggers) {
      triggers.forEach(el => {
        const target = document.getElementById(el.dataset.sidebar);

        if( target ) {
          const sidebar = new Sidebar(target)
          el.addEventListener('click', e => {
            e.preventDefault();
            sidebar.show();
          })
        }
      })
    }
  }

  /**
   * Build flickity slider for the slider of HP
   */
  sliderCover() {
    const slider = document.querySelector('.slider-cover')
    if( slider ) {
      const slides = slider.querySelector('.slider-cover__slides');
      const constslidesItem = slider.querySelectorAll('.slider-cover__slides article.slider-cover__slide').length;
      const imgs = slider.querySelectorAll('.slider-cover__img');
      let current = -1;

      if( slides && constslidesItem > 1) {
        // Content slider
        const flkty = new Flickity(slides, {
          fade              : true, 
          prevNextButtons   : false,
          draggable         : false,
          cellSelector      : '.slider-cover__slide',
          autoPlay          : 6000,
          on                : {
            select : ( index ) => {
              if( current >= 0 ) gsap.to(imgs[current], { duration: .4, autoAlpha: 0 });
              gsap.fromTo(imgs[index], { scale: 1.2, autoAlpha: 0 }, { duration : 1, scale: 1, autoAlpha: 1, ease : 'power4.easeOut' });
              current = index;
            }
          }
        })
      }
      else {
         // Content slider
         const flkty = new Flickity(slides, {
          fade              : true, 
          prevNextButtons   : false,
          draggable         : false,
          pageDots          : false,
          cellSelector      : '.slider-cover__slide',
          on                : {
            select : ( index ) => {
              if( current >= 0 ) gsap.to(imgs[current], { duration: .4, autoAlpha: 0 });
              gsap.fromTo(imgs[index], { scale: 1.2, autoAlpha: 0 }, { duration : 1, scale: 1, autoAlpha: 1, ease : 'power4.easeOut' });
              current = index;
            }
          }
        })
      }
    }
  } 

  /**
   * Build flickity slider for img with block text
   */
  sliderImg() {
    const slider = document.querySelector('.slider-img')
    if( slider ) {
      const slides = slider.querySelector('.slider-img__imgs');
      const imgs = slides.querySelectorAll('img');
      const content = slider.querySelector('.slider-img__content .inner');
      const body = slider.querySelectorAll('.slider-img__slide .wysiwyg');
      const icons = slider.querySelectorAll('.slider-img__icons .icon');
      let current = -1;

      if( slides ) {
        // Content sliderslider.querySelector('.slider-img__imgs');
        // const flkty2 = new Flickity(content, {
        //   // draggable         : false,
        //   pageDots          : false,
        //   wrapAround        : true,
        //   prevNextButtons   : false ,
        //   adaptiveHeight    : true,
        //   fade              : true,
        //   on                : {
        //     select : ( index ) => {
        //       if( index == current ) return;

        //       if( current >= 0 ) gsap.to(body[current].children, { duration: .8, autoAlpha: 0, y : '-4rem', z: '0rem', stagger : 0.1, ease : 'expo.easeOut' });
        //       gsap.fromTo(body[index].children, { y : '4rem', autoAlpha: 0 }, { duration : 1, y: 0, z: '0rem', stagger: 0.2, autoAlpha: 1, ease : 'power4.easeOut', delay: 0.5 });
        //       current = index;
        //     }, 

        //   }
        // })
        
        const flkty1 = new Flickity(slides, {
          // draggable         : false,
          wrapAround        : true,
          selectedAttraction: 0.01,
          friction          : 0.2,
          on                : {
            select : function(index) {
              // flkty2.select(index, true, true);
              let delay = 0;
              let c = current

              if( current >= 0 ) {
                gsap.to(body[current].children, { duration: .8, autoAlpha: 0, y : '-4rem', z: '0rem', stagger : 0.1, ease : 'expo.easeOut', onComplete : () => {
                  gsap.set(body[c].parentNode, { autoAlpha : 0 });
                } });
                gsap.to(icons[current], { duration: 0.35, autoAlpha: 0, x : '-20%', ease : 'power4.easeInOut' }); 
                
                delay = 0.5;
              }

              gsap.set(content, { height : body[index].offsetHeight });
              gsap.set(body[index].parentNode, { autoAlpha : 1 });
              gsap.fromTo(icons[index], {autoAlpha : 0, x : '20%' }, { duration: 0.35, autoAlpha : 1, x: '0%', ease : 'power4.easeOut', delay : delay });
              gsap.fromTo(body[index].children, { y : '4rem', autoAlpha: 0 }, { duration : 1, y: 0, z: '0rem', stagger: 0.2, autoAlpha: 1, ease : 'power4.easeOut', delay: delay});
              current = index;
            },
          }
        })
      }
    }
  } 

  /**
   * Menu handle
   */
  menu() {
    const toggleMenu = document.querySelector('.toggle-menu');
    const mainNav = document.querySelector('.main-nav');
    const secondaryNav = document.querySelector('.secondary-nav');
    let timer = 0;
    if( toggleMenu ) {
      toggleMenu.addEventListener('click', e => {
        e.preventDefault();

        HTML.classList.toggle('open-menu')

        if( HTML.classList.contains('open-menu') ) {
          mainNav.classList.remove('-translate-x-full')
          secondaryNav.classList.remove('-translate-x-full')
          clearTimeout(timer);
        } else {
          mainNav.classList.add('-translate-x-full')
          secondaryNav.classList.add('-translate-x-full')  
          
          timer = setTimeout(() => {

            HTML.classList.remove('open-submenu')
            document.querySelectorAll('.submenu').forEach((sub) => {
              sub.classList.add('hidden')
            })

          }, 500);
        }
      })

      // Submenu
      const links = mainNav.querySelectorAll('.has-children')
      if( links ) {
        links.forEach(link => {
          link.querySelector('a').addEventListener('click', (e) => {
            if( HTML.classList.contains('open-menu') ) {
              e.preventDefault();
              const submenu = link.querySelector('.submenu')

              HTML.classList.toggle('open-submenu')
              submenu.classList.remove('hidden')

              // Content 
              const back = submenu.querySelector('.btn-back')
              if( back ) {
                back.addEventListener('click', e => {
                  e.preventDefault();

                  HTML.classList.remove('open-submenu')

                  setTimeout(() => {
                    submenu.classList.add('hidden')
                  }, 500)
                })
              }
            }
          })
        })
      }
    }
  }

  /**
   * Build carousel product
   */
  carousel() {
    const carousels = document.querySelectorAll('.carousel')
    if( carousels ) {
      carousels.forEach(carousel => {
        let current = -1;
        
        const flkty = new Flickity(carousel, {
          cellAlign         : 'left',
          draggable         : carousel.dataset.optionsDraggable ? true : false,
          pageDots          : carousel.classList.contains('carousel-store') ? true : false,
          contain           : carousel.dataset.optionsDraggable ? true : false,
          on                : {
            select : function(index) {
              if( carousel.dataset.optionsDraggable ) return;
  
              const nbVisible = Math.round(this.size.width / this.selectedSlide.outerWidth);
              if( index + nbVisible == this.slides.length ) {
                this.nextButton.element.setAttribute('disabled', 'disabled')
              } else {
                this.nextButton.element.removeAttribute('disabled')
              }
  
              this.slides.forEach((slide, i) => {
                this.cells[i].element.classList.remove('current', 'before')
                if(this.cells[i].parent.element.classList.contains('carousel-store')){
                  this.cells[i].element.style.opacity = "0"
                }
                if( i < index) {
                  this.cells[i].element.classList.add('before')
                  this.cells[i].element.classList.remove('current')
                  if(this.cells[i].parent.element.classList.contains('carousel-store')){
                    this.cells[i].element.style.opacity = "0"
                  }
                } else if( i < nbVisible + index) {
                  this.cells[i].element.classList.add('current')
                  if(this.cells[i].parent.element.classList.contains('carousel-store')){
                    this.cells[i].element.style.opacity = "1"
                  }
                } 
              })
            }
          }
        })
      })
    }
  }

  /**
   * Build carousel center product
   */
   carouselCenter() {
    const carousels = document.querySelectorAll('.carousel-center')
    if( carousels ) {
      carousels.forEach(carousel => {
        let current = -1;
        
        const flkty = new Flickity(carousel, {
          draggable         : carousel.dataset.optionsDraggable ? true : false,
          pageDots          : carousel.classList.contains('carousel-store') ? true : false,
          contain           : carousel.dataset.optionsDraggable ? true : false,
          on                : {
            select : function(index) {
              if( carousel.dataset.optionsDraggable ) return;
  
              const nbVisible = Math.round(this.size.width / this.selectedSlide.outerWidth);
              if( index + nbVisible == this.slides.length ) {
                this.nextButton.element.setAttribute('disabled', 'disabled')
              } else {
                this.nextButton.element.removeAttribute('disabled')
              }
  
              this.slides.forEach((slide, i) => {
                this.cells[i].element.classList.remove('current', 'before')
                if(this.cells[i].parent.element.classList.contains('carousel-store')){
                  this.cells[i].element.style.opacity = "0"
                }
                if( i < index) {
                  this.cells[i].element.classList.add('before')
                  this.cells[i].element.classList.remove('current')
                  if(this.cells[i].parent.element.classList.contains('carousel-store')){
                    this.cells[i].element.style.opacity = "0"
                  }
                } else if( i < nbVisible + index) {
                  this.cells[i].element.classList.add('current')
                  if(this.cells[i].parent.element.classList.contains('carousel-store')){
                    this.cells[i].element.style.opacity = "1"
                  }
                } 
              })
            }
          }
        })
      })
    }
  }
  
  /**
   * Build category carousel if too much category
   */
  carouselCategory() {
    const _ = this;
    const carousel = document.querySelectorAll('.category-carousel')
    const list = document.querySelector('.category-list')
    const nav = document.querySelector('.category-nav')

    if( list && nav ) {
      window.addEventListener('scroll', (e) => {
        const pos = list.getBoundingClientRect();

        if( pos.bottom <= 0 ) {
          nav.classList.add('show')
        } else {
          nav.classList.remove('show')
        }
      })
    }

    if( carousel ) {

      carousel.forEach(c => {
        const flkty = new Flickity(c, {
          cellAlign         : 'center',
          groupCells        : '100%',
          pageDots          : false,
          contain           : true,
          on                : {
            ready : function() {
              let width = 0;
              this.cells.forEach(el => width += el.size.outerWidth )
              if( width > this.size.width) c.classList.add('show-nav')
            }
          }
        })
      })
    }
  }

  /**
   * 'Select your perfume' button scroll.
   */
  nextStepScroll() {
    const _ = this;
    const button = document.querySelector('a.btn-add-to-cart-custom');
    const registerFormMessage = document.querySelector('#comptoir_ajax_login_user_register_form_messages');
    if (button && !button.classList.contains('scroll-init')) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const $target = document.querySelector(button.hash)
        if ($target) {
          let pos = $target.getBoundingClientRect();
          if( _.scroll ) {
            _.scroll.scrollTo(pos.top + _.scrollY)
          } else {
            gsap.to(
              document.querySelectorAll('html, body'),
              {
                duration: 0.8,
                scrollTop: window.scrollY + pos.top,
                ease: "expo.out"
              }
            )
          }
        }

        button.classList.add('scroll-init')
      });
    }
  }

  /**
   * Error message scroll.
   */
   errorMessageScroll() {
    const _ = this;
    const registerFormMessage = document.querySelector('#comptoir_ajax_login_user_register_form_messages');

    if(registerFormMessage && !registerFormMessage.classList.contains('register-form-error-message-proceed')) {
      const target = registerFormMessage.querySelector('div[role="contentinfo"]')
      if (target) {
        document.querySelector('aside.sidebar__content .scroll').scrollTo({
          top: 0,
          behavior: "smooth"
        })
      }
      registerFormMessage.classList.add('register-form-error-message-proceed');
    }
  }
}

let app = null;

Drupal.behaviors.comptoirApp = {
  attach: function() {
    if (app) {
      app.popup();
      app.selectScroll();
      app.customPackageAtribute();
      app.nextStepScroll();
      app.errorMessageScroll();
      app.customScroll();
      app.faqScroll();
    }  
  }
};

window.addEventListener('DOMContentLoaded', () => {
  app = new App();
  app.customScroll();
  app.nextStepScroll();
  app.errorMessageScroll();
  app.selectScroll();
  app.customPackageAtribute();
  app.popup();
  app.faqScroll();
})

